export default "__VITE_ASSET__FXL9ieKR__"